import { SelectOption } from "global";
import usStates from "jsonData/usStates.json";

export const initialDeliveryFormValue = {
  city: "",
  state: "",
  country: "",
  postalCode: "",
  streetAddress: "",
};

export const usStatesOptions: SelectOption[] = usStates;
